export function setupVWOErrorHandler(): void {
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const errorMessage = event.reason?.message || String(event.reason) || '';
    const stack = event.reason?.stack || '';

    if (isVWOError(errorMessage, stack)) {
      event.preventDefault();
      logVWOError(errorMessage);
    }
  });

  window.addEventListener('error', (event: ErrorEvent) => {
    const errorMessage = event.message || '';
    const source = event.filename || '';

    if (isVWOError(errorMessage, source)) {
      event.preventDefault();
      logVWOError(errorMessage);
    }
  });
}

function isVWOError(message: string, source: string): boolean {
  const vwoErrorPatterns = ['Load failed', 't is not a function', 'Promise'];
  const vwoSources = ['visualwebsiteoptimizer.com', 'vwoCode', 'test.glite.ai'];
  const hasVWOMessage = vwoErrorPatterns.some((pattern) => message.includes(pattern));
  const hasVWOSource = vwoSources.some((sourcePattern) => source.includes(sourcePattern));
  return hasVWOMessage && hasVWOSource;
}

function logVWOError(message: string): void {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('VWO Script Error Suppressed:', message);
  }
}
